import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { AutoUnsubscribe } from '@thx/decorators';
import { Subscription } from 'rxjs';
import { IconsService } from './icons.service';

@AutoUnsubscribe
@Directive({
  selector: '[thxIcons]',
  host: {
    '[class.anticon]': 'true',
  },
})
export class IconsDirective implements OnChanges, OnInit {
  @Input() name!: string;
  @Input() color!: string;
  @Input() size!: string;
  @Input() originalSize!: boolean;
  @Input() stroke?: string;
  private readonly SIZE_DEFAULT = '1.5em';
  private readonly COLOR_DEFAULT = 'currentColor';

  private _iconExistsSubscription?: Subscription;

  constructor(
    private _elementRef: ElementRef,
    private _renderer: Renderer2,
    private _iconService: IconsService,
  ) {}

  ngOnInit() {
    this._renderer.addClass(this._elementRef.nativeElement, 'anticon');
  }

  ngOnChanges(): void {
    this.color = this.color || this.COLOR_DEFAULT;
    this.size = this.size || this.SIZE_DEFAULT;
    if (this.name) {
      this._iconExistsSubscription = this._iconService.iconExists(this.name).subscribe((iconExists: boolean) => {
        if (iconExists) {
          this._changeIcon().then((svg: SVGGraphicsElement) => {
            !this.originalSize && this._iconService._removeWhiteSpacesFromSvg(svg);
          });
        } else {
          throw new Error(`Icon name '${this.name}' not found`);
        }
      });
    }
  }

  private _changeIcon(): Promise<SVGGraphicsElement> {
    return new Promise<SVGGraphicsElement>((resolve) => {
      resolve(
        this._setSvgElement(
          this._iconService.getRenderedContent({
            name: this.name,
            size: this.size,
            color: this.color,
            stroke: this.stroke,
          }),
        ),
      );
    });
  }

  private _setSvgElement(svg: SVGElement): SVGGraphicsElement {
    this._renderer.appendChild(this._elementRef.nativeElement, svg);
    return svg as SVGGraphicsElement;
  }
}
